/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimelineHistory from '../../../../../../../components/ui-elements/timeline/TimelineHistory';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { getAllOrgByHistory } from '../../../../../../../store/reducers/organization/orgApp/orgAppAction';

const OrgAppHistory = ({ selectedOrgApp }) => {
    const [historyList, setHistoryList] = useState([]);
    const dispatch = useDispatch();
    const orgAppHistory = useSelector(state => state.orgApp.orgAppHistory)
    useEffect(() => {
        dispatch(getAllOrgByHistory({ "organizationApplicationID": selectedOrgApp.organizationApplicationID }));
    }, [dispatch, selectedOrgApp]);

    useEffect(() => {
        setHistoryList([]);
        if (orgAppHistory?.length > 0) {
            orgAppHistory.forEach(element => {
                setHistoryList(item => [...item, {
                    ...element, Record: {
                        name: element.Record.organizationApplicationName,
                        details: element.Record.organizationApplicationDetails,
                        createdBy: element.Record.createdBy ?? "",
                        updatedBy: element.Record.updatedBy ?? "",
                    }
                }]);
            });
        }
    }, [orgAppHistory]);
    return (
        <>
            <Typography variant="h3" align="center" color="success.light">Organization Application History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}


export default OrgAppHistory;